export default __webpack_public_path__ + "static/media/sn15.e9f3f07a.jpg";